<div class="floating-filter-header">
  <lib-button
    (click)="resetColumns()"
    [img]="isDisabled ? 'images/clear-disabled.svg' : 'images/clear.svg'"
    [disabled]="isDisabled"
    class="grid-reset"
  >
    {{ 'GENERAL.CLEAR' | translate | uppercase }}
  </lib-button>
</div>
